// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:640px){#categoriesf>div[data-v-5bf58138]:after{display:none}}#numbers span[data-v-5bf58138]{font-size:1.875rem;color:#f9bb8e;color:rgba(249,187,142,var(--text-opacity))}#numbers h2[data-v-5bf58138],#numbers span[data-v-5bf58138]{font-weight:700;--text-opacity:1}#numbers h2[data-v-5bf58138]{font-size:1.5rem;color:#5f8b7a;color:rgba(95,139,122,var(--text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
